import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'

import Slider from '../../../../components/slider'

class ComfortSlider extends PureComponent {
  render() {
    return (
      <Slider
        label="Comfort"
        max={2}
        maxLabel="Comfortable"
        min={-2}
        minLabel="Uncomfortable"
        readOnly
        value={this.props.value}
      />
    )
  }
}

ComfortSlider.propTypes = {
  value: PropTypes.number
}

export default ComfortSlider
